define("shared/components/shared/post/secondary/hashtag-suggestions/search", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/array", "@ember/runloop", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "lodash", "later/utils/fetch", "later/utils/is-valid-hashtag", "shared/utils/get-hashtags", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _array, _runloop, _service, _utils, _component2, _tracking, _emberConcurrency, _lodash, _fetch, _isValidHashtag, _getHashtags, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _hashtagType, _shouldQuery, _getHighestScore, _formatSearchHashtagsForTable, _setLoadingState;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/array",0,"@ember/runloop",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"lodash",0,"later/utils/fetch",0,"later/utils/is-valid-hashtag",0,"shared/utils/get-hashtags",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateFieldGet(e, t) { var r = _classPrivateFieldGet2(t, e); return _classApplyDescriptorGet(e, r); }
  function _classPrivateFieldGet2(s, a) { return s.get(_assertClassBrand(s, a)); }
  function _classApplyDescriptorGet(e, t) { return t.get ? t.get.call(e) : t.value; }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <form class="u--p__lr__lg u--m__b__0" {{action (perform this.queryHashtag) on="submit"}}>
    <div>
      {{t "hashtag_suggestions.subtitle"}}
    </div>
  
    <div class="u--row u--m__t__sm">
  
      <div class="u--col__8 u--p__r__0 u--m__b__xs">
        <div class="o--inputAction--light u--p__l__lg">
          <Input
            @type="text"
            @value={{@hashtagQuery}}
            aria-label={{t "hashtag_suggestions.input_placeholder"}}
            class="o--inputAction__input qa--postmodal_htInput"
            disabled={{this.hasReachedSearchLimit}}
            placeholder={{t "hashtag_suggestions.input_placeholder"}}
          />
          {{svg-jar "hashtag" class="o--icon--xs o--icon--light o--inputAction__icon--left" tabindex="0"}}
        </div>
        {{#if this.invalidHashtag}}
          <span class="o--form__helpText u--text--danger">
            {{t "hashtag_suggestions.error_invalid"}}
          </span>
        {{/if}}
      </div>
  
      <div class="u--col__4 u--p__r__0 u--m__b__xs">
        <Shared::Ui::Button
          @additional="block"
          @isDisabled={{not this.canSubmit}}
          @text={{t "hashtag_suggestions.button_cta"}}
          type="submit"
        />
      </div>
    </div>
  </form>
  
  {{#if this.isSearchingHashtags}}
    <Shared::Ui::CalculatingState
      @text={{t "hashtag_suggestions.loading"}}
      class="u--text--uppercase u--text--light u--text--center u--text--sm"
    />
  {{else if this.areHashtagsFound}}
    <div class="u--p__lr__lg u--p__tb__sm u--clearfix">
      <div class="u--float--left">
        <span class="u--text--sm u--text--light">
          {{! Note: you will only see this if canSmartHashtags is true }}
          {{! which happens when you still have remaining hashtags searches for your plan. }}
          {{! Otherwise you will see UpgradeModal instead of Search }}
          {{#if @planHasLimitedHashtagSearches}}
            {{t "hashtag_suggestions.search.limited" count=@numberOfHashtagsSearches}}
          {{else}}
            {{@selectedHashtags.length}}
            {{t "shared_words.selected"}}
          {{/if}}
        </span>
      </div>
    </div>
    <hr class="u--m__tb__0" />
    <Shared::Post::Secondary::HashtagSuggestions::Table
      @selectHashtag={{@selectHashtag}}
      @selectedHashtags={{@selectedHashtags}}
      @suggestedHashtags={{@searchHashtags}}
    />
  {{else if (and @planHasLimitedHashtagSearches (not this.isEmpty))}}
    <div class="o--blank u--p__b__0">
      <p class="o--blank__desc">
        {{t "hashtag_suggestions.search.limited" count=@numberOfHashtagsSearches}}
      </p>
      <div class="img--empty__searchHashtagSuggestions"></div>
    </div>
  {{/if}}
  
  {{#if (and this.isEmpty (not this.isSearchingHashtags))}}
    <Shared::Post::Secondary::HashtagSuggestions::Empty @isSearch={{true}} @suggestedHashtags={{@searchHashtags}} />
  {{/if}}
  
  {{#if this.isError}}
    <Shared::Post::Secondary::HashtagSuggestions::Error @hashtagQuery={{@hashtagQuery}} @isSearch={{true}} />
  {{/if}}
  */
  {
    "id": "NgtETlgQ",
    "block": "[[[11,\"form\"],[24,0,\"u--p__lr__lg u--m__b__0\"],[4,[38,0],[[30,0],[28,[37,1],[[30,0,[\"queryHashtag\"]]],null]],[[\"on\"],[\"submit\"]]],[12],[1,\"\\n  \"],[10,0],[12],[1,\"\\n    \"],[1,[28,[35,2],[\"hashtag_suggestions.subtitle\"],null]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"u--row u--m__t__sm\"],[12],[1,\"\\n\\n    \"],[10,0],[14,0,\"u--col__8 u--p__r__0 u--m__b__xs\"],[12],[1,\"\\n      \"],[10,0],[14,0,\"o--inputAction--light u--p__l__lg\"],[12],[1,\"\\n        \"],[8,[39,3],[[16,\"aria-label\",[28,[37,2],[\"hashtag_suggestions.input_placeholder\"],null]],[24,0,\"o--inputAction__input qa--postmodal_htInput\"],[16,\"disabled\",[30,0,[\"hasReachedSearchLimit\"]]],[16,\"placeholder\",[28,[37,2],[\"hashtag_suggestions.input_placeholder\"],null]]],[[\"@type\",\"@value\"],[\"text\",[30,1]]],null],[1,\"\\n        \"],[1,[28,[35,4],[\"hashtag\"],[[\"class\",\"tabindex\"],[\"o--icon--xs o--icon--light o--inputAction__icon--left\",\"0\"]]]],[1,\"\\n      \"],[13],[1,\"\\n\"],[41,[30,0,[\"invalidHashtag\"]],[[[1,\"        \"],[10,1],[14,0,\"o--form__helpText u--text--danger\"],[12],[1,\"\\n          \"],[1,[28,[35,2],[\"hashtag_suggestions.error_invalid\"],null]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"u--col__4 u--p__r__0 u--m__b__xs\"],[12],[1,\"\\n      \"],[8,[39,6],[[24,4,\"submit\"]],[[\"@additional\",\"@isDisabled\",\"@text\"],[\"block\",[28,[37,7],[[30,0,[\"canSubmit\"]]],null],[28,[37,2],[\"hashtag_suggestions.button_cta\"],null]]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"isSearchingHashtags\"]],[[[1,\"  \"],[8,[39,8],[[24,0,\"u--text--uppercase u--text--light u--text--center u--text--sm\"]],[[\"@text\"],[[28,[37,2],[\"hashtag_suggestions.loading\"],null]]],null],[1,\"\\n\"]],[]],[[[41,[30,0,[\"areHashtagsFound\"]],[[[1,\"  \"],[10,0],[14,0,\"u--p__lr__lg u--p__tb__sm u--clearfix\"],[12],[1,\"\\n    \"],[10,0],[14,0,\"u--float--left\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"u--text--sm u--text--light\"],[12],[1,\"\\n\"],[41,[30,2],[[[1,\"          \"],[1,[28,[35,2],[\"hashtag_suggestions.search.limited\"],[[\"count\"],[[30,3]]]]],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[30,4,[\"length\"]]],[1,\"\\n          \"],[1,[28,[35,2],[\"shared_words.selected\"],null]],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"hr\"],[14,0,\"u--m__tb__0\"],[12],[13],[1,\"\\n  \"],[8,[39,9],null,[[\"@selectHashtag\",\"@selectedHashtags\",\"@suggestedHashtags\"],[[30,5],[30,4],[30,6]]],null],[1,\"\\n\"]],[]],[[[41,[28,[37,10],[[30,2],[28,[37,7],[[30,0,[\"isEmpty\"]]],null]],null],[[[1,\"  \"],[10,0],[14,0,\"o--blank u--p__b__0\"],[12],[1,\"\\n    \"],[10,2],[14,0,\"o--blank__desc\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"hashtag_suggestions.search.limited\"],[[\"count\"],[[30,3]]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"img--empty__searchHashtagSuggestions\"],[12],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[]]]],[]]],[1,\"\\n\"],[41,[28,[37,10],[[30,0,[\"isEmpty\"]],[28,[37,7],[[30,0,[\"isSearchingHashtags\"]]],null]],null],[[[1,\"  \"],[8,[39,11],null,[[\"@isSearch\",\"@suggestedHashtags\"],[true,[30,6]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"isError\"]],[[[1,\"  \"],[8,[39,12],null,[[\"@hashtagQuery\",\"@isSearch\"],[[30,1],true]],null],[1,\"\\n\"]],[]],null]],[\"@hashtagQuery\",\"@planHasLimitedHashtagSearches\",\"@numberOfHashtagsSearches\",\"@selectedHashtags\",\"@selectHashtag\",\"@searchHashtags\"],false,[\"action\",\"perform\",\"t\",\"input\",\"svg-jar\",\"if\",\"shared/ui/button\",\"not\",\"shared/ui/calculating-state\",\"shared/post/secondary/hashtag-suggestions/table\",\"and\",\"shared/post/secondary/hashtag-suggestions/empty\",\"shared/post/secondary/hashtag-suggestions/error\"]]",
    "moduleName": "shared/components/shared/post/secondary/hashtag-suggestions/search.hbs",
    "isStrictMode": false
  });
  let SearchComponent = _exports.default = (_class = (_hashtagType = /*#__PURE__*/new WeakMap(), _shouldQuery = /*#__PURE__*/new WeakSet(), _getHighestScore = /*#__PURE__*/new WeakSet(), _formatSearchHashtagsForTable = /*#__PURE__*/new WeakSet(), _setLoadingState = /*#__PURE__*/new WeakSet(), class SearchComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _classPrivateMethodInitSpec(this, _setLoadingState);
      _classPrivateMethodInitSpec(this, _formatSearchHashtagsForTable);
      _classPrivateMethodInitSpec(this, _getHighestScore);
      _classPrivateMethodInitSpec(this, _shouldQuery);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "errors", _descriptor2, this);
      _initializerDefineProperty(this, "segment", _descriptor3, this);
      _classPrivateFieldInitSpec(this, _hashtagType, {
        writable: true,
        value: 'search'
      });
      _initializerDefineProperty(this, "isError", _descriptor4, this);
      _initializerDefineProperty(this, "isEmpty", _descriptor5, this);
      _initializerDefineProperty(this, "isSearchingHashtags", _descriptor6, this);
      _initializerDefineProperty(this, "previousQuery", _descriptor7, this);
      _defineProperty(this, "queryHashtag", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          const queryTag = this.args.hashtagQuery.toLowerCase();
          this.args.updateHashtagQuery(this.formattedHashtagQuery);

          // Avoid Calling the same API repeatedly / invalid queries
          if (_classPrivateMethodGet(this, _shouldQuery, _shouldQuery2).call(this, queryTag)) {
            this.previousQuery = queryTag;
            this.args.updateSearchHashtags((0, _array.A)());
            this.args.updateSelectedSearchHashtags((0, _array.A)());
            yield this._processHashtagQuery.perform(queryTag);
          }
        }
      }), null, "queryHashtag", "restartable"));
      _defineProperty(this, "_processHashtagQuery", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* (queryTag) {
          try {
            _classPrivateMethodGet(this, _setLoadingState, _setLoadingState2).call(this);
            const {
              query = '',
              hashtag_suggestions: rawSearchHashtags
            } = yield (0, _fetch.fetch)(`/api/v2/hashtag_suggestions.json?query_tag=${queryTag}`);
            this.args.updateHashtagQuery(query);
            this.isEmpty = (0, _lodash.isEmpty)(rawSearchHashtags);
            const formattedSearchHashtags = _classPrivateMethodGet(this, _formatSearchHashtagsForTable, _formatSearchHashtagsForTable2).call(this, rawSearchHashtags);
            const trackingData = this.args.formatTrackingData({
              hashtag_count: 1,
              hashtag_list: formattedSearchHashtags.map(_ref => {
                let {
                  hashtag
                } = _ref;
                return hashtag;
              }),
              base_hashtag: query,
              hashtag_type: [_classPrivateFieldGet(this, _hashtagType)]
            });
            this.segment.track('suggested-hashtags', trackingData);
            if (this.args.planHasLimitedHashtagSearches) {
              yield this.auth.currentAccount.reload();
            }
            this.isError = false;
          } catch (error) {
            this.isError = true;
            this.args.updateHashtagQuery(queryTag);
            this.errors.log(error);
          }
        }
      }), null, "_processHashtagQuery", null));
    }
    get hasHashtagQuery() {
      return (0, _utils.isPresent)(this.args.hashtagQuery);
    }
    get areHashtagsFound() {
      return (0, _utils.isPresent)(this.args.searchHashtags);
    }
    get canSubmit() {
      return this.hasHashtagQuery && !this.invalidHashtag;
    }
    get formattedHashtagQuery() {
      return this.args.hashtagQuery.replace(/\s|#/g, '');
    }
    get invalidHashtag() {
      return this.hasHashtagQuery ? !(0, _isValidHashtag.isValidHashtag)(this.formattedHashtagQuery) : false;
    }
    get usedHashtags() {
      return (0, _getHashtags.default)(this.args.currentText);
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "errors", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "isError", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isEmpty", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isSearchingHashtags", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "previousQuery", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return null;
    }
  })), _class);
  function _shouldQuery2(query) {
    return !!query && query !== this.previousQuery && !this.invalidHashtag;
  }
  function _getHighestScore2(rawSearchHashtags) {
    if ((0, _lodash.isEmpty)(rawSearchHashtags)) {
      return null;
    }
    const maxScore = (0, _lodash.max)(rawSearchHashtags.map(_ref2 => {
      let {
        score
      } = _ref2;
      return score;
    }));
    if (maxScore === undefined) {
      this.errors.log(new Error('Cannot compute score for search hashtags'));
      return null;
    }
    return maxScore;
  }
  function _formatSearchHashtagsForTable2(rawSearchHashtags) {
    const highestScore = _classPrivateMethodGet(this, _getHighestScore, _getHighestScore2).call(this, rawSearchHashtags);
    if (!highestScore) {
      return this.args.updateSearchHashtags((0, _array.A)());
    }
    const processedSearchHashtags = rawSearchHashtags.map(hashtag => {
      const calculatedScore = Math.round(hashtag.score / highestScore * 100);
      const addedAttributes = {
        noPosts: hashtag.num_posts === null,
        formattedNumPosts: hashtag.num_posts ? hashtag.num_posts.toLocaleString() : null,
        calculatedScore: calculatedScore === 100 ? 99 : calculatedScore,
        type: _classPrivateFieldGet(this, _hashtagType)
      };
      return {
        ...hashtag,
        ...addedAttributes
      };
    }).filter(_ref3 => {
      let {
        hashtag
      } = _ref3;
      return !this.usedHashtags.includes(hashtag);
    }).sort((a, b) => b.calculatedScore - a.calculatedScore);
    return this.args.updateSearchHashtags((0, _array.A)(processedSearchHashtags));
  }
  function _setLoadingState2() {
    this.isSearchingHashtags = true;
    (0, _runloop.later)(() => {
      this.isSearchingHashtags = false;
    }, 750);
  }
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, SearchComponent);
});